var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "01) Icons/Filled/file-fill"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3332 4.64104L20.6988 9.33337H17.1662C16.7065 9.33337 16.3332 8.88887 16.3332 8.34171V4.64104ZM23.031 8.54937L17.8452 2.71604C17.6247 2.47221 17.3108 2.33337 16.9818 2.33337H7.6485C6.0035 2.33337 4.6665 3.64237 4.6665 5.25004V22.75C4.6665 24.3577 6.0035 25.6667 7.6485 25.6667H20.3512C21.9962 25.6667 23.3332 24.3577 23.3332 22.75V9.33337C23.3332 9.04287 23.2258 8.76404 23.031 8.54937Z",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_4262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 20,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3332 4.64104L20.6988 9.33337H17.1662C16.7065 9.33337 16.3332 8.88887 16.3332 8.34171V4.64104ZM23.031 8.54937L17.8452 2.71604C17.6247 2.47221 17.3108 2.33337 16.9818 2.33337H7.6485C6.0035 2.33337 4.6665 3.64237 4.6665 5.25004V22.75C4.6665 24.3577 6.0035 25.6667 7.6485 25.6667H20.3512C21.9962 25.6667 23.3332 24.3577 23.3332 22.75V9.33337C23.3332 9.04287 23.2258 8.76404 23.031 8.54937Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_4262)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckin);
export default __webpack_public_path__ + "static/media/iconCheckin.0475dd2cd2fd0e92a3097802cabadb03.svg";
export { ForwardRef as ReactComponent };